function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fillRule: "nonzero",
  d: "M0 0h12v12H0z"
}), React.createElement("path", {
  fill: "#595959",
  d: "M1.041 2.84h2.505L4.14 0h1.45l-.593 2.84h3.34L8.932 0h1.45l-.593 2.84h2.22L11.81 3.85H9.59l-.9 4.32h2.483l-.198 1.007H8.492L7.898 12H6.426l.593-2.824H3.7L3.107 12H1.634l.594-2.824H.008l.198-1.008h2.22l.9-4.32H.844l.198-1.008zm2.857 5.328h3.319l.9-4.32H4.8l-.9 4.32z"
}));

var SvgIcNumber = function SvgIcNumber(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcNumber, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-number.a47dc5e9.svg";
export { ForwardRef as ReactComponent };